import regexps from '../constants/regexps';

const replaceTitleInHtml = (html, newTitle = '') => {
  const match = html.match(regexps.TITLE);
  const titleFullHTML = match && match[0];
  const titleContent = match && match[1];

  if (newTitle && titleContent === newTitle) {
    return html;
  }

  const newHTML = `<title>${newTitle}</title>`;

  if (!titleFullHTML) {
    return html.replace('<head>', `<head>${newHTML}`);
  }

  return html.replace(titleFullHTML, newHTML);
};

export default replaceTitleInHtml;
